import React, { useState, useEffect } from 'react'
import logo from "../../thirdAssets/Images/dentcareLogo.png"
import { FaTwitter, FaFacebookF, FaLinkedinIn, FaInstagram, FaYoutube } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { IoCallSharp } from "react-icons/io5";

const MainFooter = (props) => {
    const { selectedLanguage } = props
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return (
        <div className="main">
            <div className='third-design-footer-stay-section'>
                <div>
                    <div className='stay-connected-dentcare'>
                        <h1>{selectedLanguage?.txt_stay_connected_with_dentcare}</h1>
                    </div>
                    <div className="third-design-footer-social-icons-div">
                        <button><FaFacebookF /></button>
                        <button><FaTwitter /></button>
                        <button><FaInstagram /></button>
                        <button><FaYoutube /></button>
                    </div>
                </div>
            </div>
            <div className=''>
                <div className='second-design-footer-1 third-design-footer-1'>
                    <div className='footer-logo-section third-design-footer-logo-section'>
                        <img src={logo} alt="" />
                        <p className='footer-img-section-text'>{selectedLanguage?.txt_it_is_important_to_take_patient}</p>
                        <p className='footer-img-section-text'><span><FaLocationDot /></span> {selectedLanguage?.txt_jl_gatot_subroto_barat}</p>
                        <p className='footer-img-section-text'><span><IoMdMail /></span> support@domain.com</p>
                    </div>
                    <div className='footer-logo-section second-design-footer-contact-section third-design-footer-appointment-text'>
                        <h2>{selectedLanguage?.txt_make_an_appointment}</h2>
                        <p className='footer-img-section-text footer-no'>{selectedLanguage?.txt_the_pain_itself_is_very_important}</p>
                        <button>
                            <IoCallSharp /> (+62)81 342 3471
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <div className="third-design-footer-2">
                    <p>{selectedLanguage?.txt_dentist_dental_clinic_template_kit_by_jegtheme}</p>
                    <p>{selectedLanguage?.footer_txt_copy_right} {currentYear}. {selectedLanguage?.txt_all_right_reserved}.</p>
                </div>
            </div>
        </div>
    )
}

export default MainFooter